(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@aws-amplify/cache"), require("@aws-amplify/core"));
	else if(typeof define === 'function' && define.amd)
		define("aws_amplify_analytics", ["@aws-amplify/cache", "@aws-amplify/core"], factory);
	else if(typeof exports === 'object')
		exports["aws_amplify_analytics"] = factory(require("@aws-amplify/cache"), require("@aws-amplify/core"));
	else
		root["aws_amplify_analytics"] = factory(root["@aws-amplify/cache"], root["@aws-amplify/core"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__aws_amplify_cache__, __WEBPACK_EXTERNAL_MODULE__aws_amplify_core__) {
return 